import { encryptionSets } from '../constants/encryption-sets'
import { shakeAndBangSets } from '../constants/shake-and-band-sets';
import { secretWords } from '../constants/index'

const MAX_COORDINATE_LENGTH = 8;
const MAX_DOT_CASES = 3;
const COORDINATE_PRECISION = 4;
export const ACTIVE_SECRET_WORD = "SECRET_WORD";

// Helper: format float to fixed decimals and return as string
function prepareCoordinate(coordinate) {
  let str = new Number(coordinate).toFixed(COORDINATE_PRECISION);
  return str.substring(0, MAX_COORDINATE_LENGTH);
}

// Helper: join array elements as string
function arrayToString(array) {
  return array.map(String).join('');
}

// Shift character in abc by n positions
function shiftChar(char, abc, n) {
  const len = abc.length;
  n = n % len;

  if (n < 0) n += len;
  const index = abc.indexOf(char);
  
  if (index === -1) return char;
  
  const newIndex = (index + n) % len;
  return abc[newIndex];
}

// Random integer [0, size)
function random(size) {
  return Math.floor(Math.random() * size);
}

function getActiveSecretWord() {
  return localStorage.getItem(ACTIVE_SECRET_WORD) || secretWords[0];
}

// Build secret word map
// THERE IS A BUG IN THIS FUNCTION
function getSecretWordMap() {
  const secretWordValue = getActiveSecretWord();
  const abc = getActiveEncryptionSet().abc;
  let allowedChars = abc.split('');
  const secretWord = secretWordValue.split('');
  const result = {};

  // Prepare basic map
  for (let index = 0; index < secretWord.length; index++) {
    result[index.toString()] = [secretWord[index].toUpperCase()];
    allowedChars = allowedChars.filter(c => c !== secretWord[index].toUpperCase());
  }

  const resultKeys = ["6", "7", "8", "9", "0", "1", "2", "3", "4", "5"];
  // Assign leftover allowed characters
  for (let i = 0; i < 3; i++) {
    for (let j = 0; j < resultKeys.length; j++) {
      const key = resultKeys[j];
      const mapItem = result[key];
      if (allowedChars.length > 0) {
        mapItem.push(allowedChars[0]);
        allowedChars.splice(0, 1);
      }
    }
  }

  return result;
}

// Get negative/positive metadata abc
function getIsNegativeMetadataAbc(isNegative) {
  const metadataAbc = getActiveEncryptionSet().metadataAbc;
  const metadataLength = metadataAbc.length;
  const isNegativeValueAbc = isNegative
    ? metadataAbc.substring(0, Math.floor(metadataLength / 2))
    : metadataAbc.substring(Math.ceil(metadataLength / 2), metadataLength);

  return {
    abc: isNegativeValueAbc,
    size: isNegativeValueAbc.length,
  };
}

// Encrypt metadata
function encryptMetadata(isNegative, dotLocation) {
  const isNegativeValueAbc = getIsNegativeMetadataAbc(isNegative);
  const abcSize = isNegativeValueAbc.size;
  const encryptedIsNegative = isNegativeValueAbc.abc[random(abcSize)];

  const dotLocationNumber = new Number(dotLocation);
  const dotAbc = getDotAbc()[isNegative ? dotLocationNumber - 2 : dotLocationNumber - 1];
  const dotLocationRandomNumber = random(dotAbc.length);
  const encryptedDotLocation = dotAbc[dotLocationRandomNumber];

  return encryptedIsNegative + encryptedDotLocation;
}

// Get dot abc sections
function getDotAbc() {
  const metadataAbc = getActiveEncryptionSet().metadataAbc;
  const result = [];
  const sectionLength = Math.floor(metadataAbc.length / MAX_DOT_CASES);

  for (let i = 0; i < MAX_DOT_CASES; i++) {
    result.push(metadataAbc.substring(i * sectionLength, (i + 1) * sectionLength));
  }
  return result;
}

// Find dot location index
function findDotLocation(encryptedLocation) {
  const dotAbc = getDotAbc();
  let dotLocation = null;
  let index = 0;
  while (index < dotAbc.length && dotLocation == null) {
    if (dotAbc[index].includes(encryptedLocation)) {
      dotLocation = index + 1;
    }
    index++;
  }
  return dotLocation;
}

// Decrypt metadata
function decryptMetadata(metadata) {
  const chars = metadata.split('');
  const isNegative = chars[0];
  const isNegativeValueAbc = getIsNegativeMetadataAbc(true);
  const isNegativeValue = isNegativeValueAbc.abc.split('').indexOf(isNegative) > 0;

  return {
    isNegative: isNegativeValue,
    dotLocationIndex: findDotLocation(chars[1])
  };
}

function getActiveShakeAndBangSet() {
  return shakeAndBangSets.find(set => set.name === localStorage.getItem("SHAKE_AND_BANG_SET")) || shakeAndBangSets[0];
}

// Encrypt coordinate string with params
function encryptWithParams(coordinateString) {
  const map = getSecretWordMap();
  const coordinateChars = coordinateString.split('');
  const isNegativeCoordinate = coordinateChars[0] === '-';
  const dotLocation = coordinateChars.indexOf('.');
  const encryptionAbc = getActiveEncryptionSet().abc;
  const currentShakeAndBang = getActiveShakeAndBangSet();

  let encrypted = "";
  let shakeAndBangIndex = 0;

  for (let index = 0; index < coordinateChars.length; index++) {
    const number = coordinateChars[index];
    const isSpecialCharacter = [".", "-"].includes(number);

    if (!isSpecialCharacter) {
      const encryptedSet = map[number];
      const encryptionLetter = encryptedSet[random(encryptedSet.length)];
      const shakeAndBangValue = currentShakeAndBang.value[shakeAndBangIndex];
      const shakeAndBangDirection = currentShakeAndBang.direction;



      encrypted += shiftChar(encryptionLetter, encryptionAbc, shakeAndBangValue * shakeAndBangDirection);
      shakeAndBangIndex++;
    }
  }

  return encryptMetadata(isNegativeCoordinate, dotLocation) + encrypted;
}

// Find decrypted coordinate
function findEncryptedCoordinate(encryptedCoordinate, map, coordinateIndex) {
  const keys = Object.keys(map);
  let decryptedValue = null;
  let index = 0;

  const encryptionAbc = getActiveEncryptionSet().abc;
  const currentShakeAndBang = getActiveShakeAndBangSet();
  const shakeAndBangValue = currentShakeAndBang.value[coordinateIndex];
  const shakeAndBangDirection = currentShakeAndBang.direction;

  while (decryptedValue == null && index < keys.length) {
    const key = keys[index];
    const shiftedCoordinate = shiftChar(
      encryptedCoordinate,
      encryptionAbc,
      shakeAndBangValue * (shakeAndBangDirection * -1)
    );

    if (map[key].includes(shiftedCoordinate)) {
      decryptedValue = key;
    }
    index++;
  }

  return decryptedValue;
}

// Decrypt coordinate string with params
function decryptWithParams(coordinateString) {
  const map = getSecretWordMap();
  const decrypted = [];

  const metadata = decryptMetadata(coordinateString.substring(0, 2));
  const coordinates = coordinateString.substring(2).split('');

  if (metadata.isNegative === true) {
    decrypted.push("-");
  }

  for (let index = 0; index < coordinates.length; index++) {
    if (index === metadata.dotLocationIndex) {
      decrypted.push(".");
    }
    decrypted.push(
      findEncryptedCoordinate(coordinates[index], map, index)
    );
  }

  return arrayToString(decrypted);
}

// Encrypt location object
export function encryptLocation(lat, long) {
  const latCoordinate = prepareCoordinate(lat);
  const longCoordinate = prepareCoordinate(long);

  const encryptedLat = encryptWithParams(latCoordinate);
  const encryptedLong = encryptWithParams(longCoordinate);

  return { lat: encryptedLat, long: encryptedLong };
}

// Decrypt location object
export function decryptLocation(encLat, encLong) {
  const decryptedLat = decryptWithParams(encLat);
  const decryptedLong = decryptWithParams(encLong);

  return { lat: decryptedLat, long: decryptedLong };
}

// Get shake and bang set index
function getShakeAndBangSetIndex() {
  const activeShakeAndBangSet = getActiveShakeAndBangSet();
  
  return shakeAndBangSets.findIndex(set => set.name === activeShakeAndBangSet.name);
}

// Get secret word index
function getSecretWordIndex() {
  const activeSecretWord = getActiveSecretWord();
  return secretWords.findIndex(word => word === activeSecretWord);
}

function getActiveEncryptionSet() {
  return encryptionSets.find(set => set.name === localStorage.getItem("ENCRYPTION_SET")) || encryptionSets[0]
}

// Get encryption set index
function getEncryptionSetIndex() {
  const activeEncryptionSet = getActiveEncryptionSet();
  return encryptionSets.findIndex(set => set.name === activeEncryptionSet.name);
}

// Get quick encryption config
export function getQuickEncryptionConfig(format) {
  const shakeAndBangIndex = getShakeAndBangSetIndex();
  const secretWordIndex = getSecretWordIndex();
  const encryptionSetIndex = getEncryptionSetIndex();

  if (format === "array") {
    return [secretWordIndex, encryptionSetIndex, shakeAndBangIndex];
  }
  return `${secretWordIndex}/${encryptionSetIndex}/${shakeAndBangIndex}`;
}

